module.exports = "/images/awpi.png?e21d1abb93def17d1ba4a4bec954e23b";